import { render, staticRenderFns } from "./ActivateCorporate.vue?vue&type=template&id=31a0f0da"
import script from "./ActivateCorporate.vue?vue&type=script&lang=js"
export * from "./ActivateCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports